import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Button } from '@frontend/design-system';
import { buttonStyle } from './common-styles';

export interface ReplyActionProps {
  onClick: () => void;
}

export const ReplyAction = ({ onClick }: ReplyActionProps) => {
  const { t } = useTranslation('team-chat');
  return (
    <Button
      variant='secondary'
      onClick={onClick}
      css={buttonStyle}
      trackingId='team-chat-2.0-open-threads'
      hoverLabel={t('Reply in Thread')}
    >
      <Icon name='chat' />
    </Button>
  );
};
